import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { en } from './locales/en';
import { pt } from './locales/pt';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en,
      pt,
    },
    fallbackLng: 'en',
    debug: import.meta.env.DEV,
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      // Order of language detection. `?lng=pt|en` comes first so links from
      // the landing page (autoclipper.live) and English emails open the app in
      // the visitor's language; it is then cached like any other choice.
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag', 'cookie'],
      // Cache user language selection
      caches: ['localStorage'],
      // Lookup keys
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: 'i18next',
    },
  });

export default i18n;
